export function validateRequiredFields(
  formData,
  requiredFields,
  validationText
) {
  const errors = [];

  // Check required fields
  for (let field of requiredFields) {
    const value = formData[field];
    if (!value || value.toString().trim() === "") {
      // Get error from validationText or fallback
      const message =
        validationText?.[`${field}Error`] || `${field} is required`;
      errors.push(message);
      continue; // skip further validation if empty
    }

    // Auto-validation based on field name
    if (/phone/i.test(field)) {
      if (value.replace(/\D/g, "").length < 6) {
        errors.push(validationText?.minLenghtPhoneError);
      }
    }

    if (/email/i.test(field)) {
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        errors.push(validationText?.invalidEmailError);
      }
    }

    if (/name$/i.test(field) || /firstName|lastName/i.test(field)) {
      if (value.trim().length < 3) {
        errors.push(validationText?.minLenghtNameError);
      }
    }

    /*    if (/date/i.test(field)) {
      const inputDate = new Date(value);
      const today = new Date();

      inputDate.setHours(0, 0, 0, 0);
      today.setHours(0, 0, 0, 0);

      if (inputDate < today) {
        errors.push(
          validationText?.pastDateError || `${field} cannot be in the past`
        );
      }
    } */
  }

  return errors;
}
